import { Kpi, Section, DataTable } from "./_shared";
import { BarChartC, PieChartC } from "../_charts";

export default function OmniOverview({ data }) {
  const t = data.totals || {};
  return (
    <div className="space-y-4" data-testid="omni-overview">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        <Kpi label="Total interactions" value={t.interactions} testid="omni-kpi-interactions" />
        <Kpi label="Inbound" value={t.inbound} testid="omni-kpi-inbound" />
        <Kpi label="Outbound" value={t.outbound} testid="omni-kpi-outbound" />
        <Kpi label="New conversations" value={t.new_conversations} testid="omni-kpi-new" />
        <Kpi label="Unique customers" value={t.unique_customers} testid="omni-kpi-customers" />
        <Kpi label="Unlinked conversations" value={t.unlinked_conversations}
          hint="Not yet matched to a CRM contact" testid="omni-kpi-unlinked" />
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
        <div className="xl:col-span-2">
          <Section title="Daily volume by channel" subtitle="Messages + calls" testid="omni-trend">
            <BarChartC data={data.trend || []} xKey="day" stacked
              yKeys={(data.trend_keys || []).map((k) => ({ id: k, label: k }))} />
          </Section>
        </div>
        <Section title="Channel mix" subtitle="Share of all interactions" testid="omni-mix">
          <PieChartC data={(data.rows || []).filter((r) => r.total)} nameKey="channel" valueKey="total" showLabels={false} />
        </Section>
      </div>
      <Section title="Inbound by hour" subtitle="When customers reach out" testid="omni-hourly">
        <BarChartC data={data.hourly || []} xKey="hour" yKeys={[{ id: "inbound", label: "Inbound" }]} height={220} />
      </Section>
      <Section title="Channel summary" testid="omni-overview-table-card">
        <DataTable columns={data.columns} rows={data.rows || []} testid="omni-overview-table" />
      </Section>
    </div>
  );
}
